import React from 'react';
import PropTypes from 'prop-types';

const Icon = props => {
  const { fill='#000000', size='44px', children, ariaLabel='', ...rest } = props;

  return (
    <svg preserveAspectRatio="xMidYMid meet" width={size} height={size} fill={fill} aria-label={ariaLabel} {...rest}>
      {children}
    </svg>
  );
};

Icon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
};

export default Icon;
